<template>
  <main
    id="js-page-content"
    role="main"
    class="page-content"
    :class="{
      isEdit: isEditMode,
    }"
  >
    <div class="row">
      <div class="subheader col-6">
        <h1 class="subheader-title">個人目標マスタ編集</h1>
      </div>
      <!-- Right content on content header A nice area to add graphs or buttons -->
      <div class="subheader-block ml-auto demo">
        <button
          type="button"
          @click="add()"
          v-if="!isEditMode"
          :disabled="btnDisable"
          class="btn btn-primary waves-effect waves-themed"
        >
          <span class="fal fa-check mr-1"></span>追加
        </button>
        <button
          type="button"
          @click="upd(false)"
          v-if="isEditMode"
          :disabled="btnDisable"
          class="btn btn-primary waves-effect waves-themed"
        >
          <span class="fal fa-check mr-1"></span>登録
        </button>
        <button
          type="button"
          @click="delConf()"
          v-if="isEditMode"
          :disabled="btnDisable"
          class="btn btn-danger waves-effect waves-themed"
        >
          <span class="fal fa-times mr-1"></span>削除
        </button>
        <button
          :disabled="btnDisable"
          type="button"
          class="btn btn-secondary waves-effect waves-themed"
          @click="$router.push('/personalGoalList')"
        >
          <span class="fal fa-reply mr-1"></span>戻る
        </button>
      </div>
    </div>
    <!-- Your main content goes below here: -->
    <div class="row">
      <div class="col-xl-12">
        <div id="panel-1" class="panel">
          <div class="panel-hdr">
            <h2>編集項目</h2>
            <div class="panel-toolbar">
              <button
                class="btn btn-panel"
                data-action="panel-collapse"
                data-toggle="tooltip"
                data-offset="0,10"
                data-original-title="Collapse"
              ></button>
              <button
                class="btn btn-panel"
                data-action="panel-fullscreen"
                data-toggle="tooltip"
                data-offset="0,10"
                data-original-title="Fullscreen"
              ></button>
            </div>
          </div>
          <div class="panel-container show" id="panel-editers">
            <div class="loader">
              <i class="fal fa-spinner-third fa-spin-4x fs-xxl"></i>
            </div>
            <div class="panel-content contents">
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">年度</div>
                <div class="col-md-5 contCnt">
                  <vSelect
                    :options="opGoal"
                    v-model="delegate.c_goal_year"
                    :disabled="isEditMode"
                    :reduce="(label:any) => label.code"
                  >
                  </vSelect>
                </div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">氏名</div>
                <div class="col-md-5 contCnt">
                  <!-- <vSelect :options="items4staffs" disabled> </vSelect> -->
                  <vSelect
                    :options="getOpStaffs()"
                    v-model="delegate.c_staff_id"
                    :reduce="(label:any) => label.c_staff_id"
                    label="c_staff_name"
                    :disabled="isEditMode"
                  ></vSelect>
                </div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">売上目標</div>
                <div class="col-md-5 contCnt">
                  <input
                    type="text"
                    name="txtSalesTargetSum1"
                    class="form-control form-control-sm"
                    maxlength="10"
                    @focus="kanmaDelEarn()"
                    @blur="kanmaInsEarn()"
                    v-model="domGoalEarnings"
                  />
                </div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">粗利目標</div>
                <div class="col-md-5 contCnt">
                  <input
                    type="text"
                    name="txtSalesTargetArari1"
                    class="form-control form-control-sm"
                    maxlength="10"
                    @focus="kanmaDelGross()"
                    @blur="kanmaInsGross()"
                    v-model="domGoalGross"
                  />
                </div>
              </div>
              <!-------------------->
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 成功通知モーダル -->
    <Mo_modal_alert ref="Mo_modal_success" @modalclosed="get()">
      <template v-slot:title>
        <i class="fal fa-check-circle text-success mr-2"></i>
        <span class="text-success fw-500">{{ message4ModalSuccess }}</span>
      </template>
      <template v-slot:body><br /></template>
      <template v-slot:footer>
        <div class="modal-footer"><br /></div>
      </template>
    </Mo_modal_alert>
    <!-- 成功通知モーダル -->
    <!-- 削除確認モーダル -->
    <Mo_modal_alert ref="Mo_modal_deleteConf">
      <template v-slot:title>
        <i class="fal fa-times-circle text-danger mr-2"></i
        >{{ message4ModalDelConf }}
      </template>
      <template v-slot:body><br /></template>
      <template v-slot:footer>
        <div class="modal-footer">
          <button
            @click="del()"
            type="button"
            class="btn btn-danger shadow-0 bootbox-accept"
          >
            はい</button
          ><button
            @click="closeModal4deleteConf()"
            type="button"
            class="btn btn-default bootbox-cancel"
          >
            いいえ
          </button>
        </div>
      </template>
    </Mo_modal_alert>
    <!-- 削除確認モーダル -->
    <!-- エラー確認モーダル -->
    <Mo_modal_alert ref="Mo_modal_errorConf">
      <template v-slot:title>
        <i class="fal fa-times-circle text-danger mr-2"></i
        >{{ message4ModalErrorConf }}
      </template>
      <template v-slot:body><br /></template>
      <template v-slot:footer>
        <div class="modal-footer">
          <button
            @click="closeModal4ErrorConf()"
            type="button"
            class="btn btn-default bootbox-cancel"
          >
            確認
          </button>
        </div>
      </template>
    </Mo_modal_alert>
    <!-- エラー確認モーダル -->
  </main>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { Cl_common } from "@/functions/Cl_common";
import Mo_modal_alert from "@/components/molecules/Mo_modal_alert.vue";
import { Cl_goal } from "@/functions/Cl_goal";
import { DtoGoalsPutReq } from "furukawa-common/src/common/dto/abst/DtoGoalsPutReq";
import { DtoGoalsGetReqImple } from "furukawa-common/src/common/dto/DtoGoalsGetReqImple";
import { DtoGoalsGetResImple } from "furukawa-common/src/common/dto/DtoGoalsGetResImple";
import { DtoGoalsPostReq } from "furukawa-common/src/common/dto/abst/DtoGoalsPostReq";
import { DtoMastersgetReq } from "furukawa-common/src/common/dto/DtoMastersGetReq";
import { Cl_master } from "@/functions/Cl_master";
import { DtoMastersGetRes } from "furukawa-common/src/common/dto/DtoMastersGetRes";
import { EntityStaff } from "../../../furukawa-common/src/common/entity/EntityStaff";
import { CommonDate4FU } from "furukawa-common/src/common/function/CommonDate4FU";

@Options({
  components: {
    Mo_modal_alert,
    vSelect,
  },
})
export default class PersonalGoalEdit extends Vue {
  //----------------------
  //DOM連携用プロパティ
  //----------------------
  delegate = new DtoGoalsGetResImple();
  delegate4list = new DtoMastersGetRes();
  btnDisable = false;
  isEditMode = true;
  // domYear = { label: "" };
  domYear = "";
  domStaffId = "";

  domGoalEarnings = "0";
  domGoalGross = "0";

  //----------------------
  //セレクトボックス用プロパティ
  //----------------------
  opGoal = CommonDate4FU.getFiscalYearOptionList();
  /**
   * 社員の選択肢を構築する用
   */
  getOpStaffs(): EntityStaff[] {
    return this.delegate4list.getStaffSortNum4NoneDelete([
      this.delegate.c_staff_id!,
    ]);
  }
  //----------------------
  //モーダル用プロパティ
  //----------------------
  message4ModalSuccess = "";
  message4ModalDelConf = "";
  message4ModalErrorConf = "";

  //----------------------
  //制御用メソッド
  //----------------------
  async mounted() {
    await this.get();
    await this.getMastersList();
  }

  //----------------------
  //基本操作用メソッド
  //----------------------
  /**
   * チェックボックスの値を数値に変換する
   * @param event
   */
  cnvCb(event: any): number {
    if (event.target.checked) {
      return 1;
    } else {
      return 0;
    }
  }
  /**
   *Masters取得用
   */
  async getMastersList() {
    //ボタン無効＋ローダー表示
    //-----------------
    this.btnDisable = true;
    const panel = document.getElementsByClassName("panel-container");
    Array.from(panel).map((element: Element) => {
      element.classList.add("enable-loader");
    });

    try {
      //処理
      //-----------------
      Cl_common.logger("処理実行社員マスタ取得");

      //準備
      //-------
      let dtoMaster = new DtoMastersgetReq();

      //検索選択肢用
      dtoMaster.getStaff4sortNum = 1;
      dtoMaster.delFlag4Staff4sortNum = 0;
      // dtoMaster.getStaff = 1;
      // dtoMaster.delFlag4staff = 0;

      // dtoMaster.getBranch = 1;
      // dtoMaster.delFlag4Branch = 0;

      //API実行
      //-------
      this.delegate4list = await Cl_master.get(dtoMaster);

      //レスポンス処理
      //-------
    } catch (error) {
      //モーダルのメッセージを設定
      this.message4ModalErrorConf = "エラーが発生しました"; //モーダル表示
      const modal: any = this.$refs.Mo_modal_errorConf;
      modal.showModal();

      this.delegate4list = new DtoMastersGetRes();
      Cl_common.logger(error);
    } finally {
      //ボタン無効解除＋ローダー非表示
      //-----------------
      this.btnDisable = false;
      Array.from(panel).map((element: Element) => {
        element.classList.remove("enable-loader");
      });
    }
  }
  /**
   * データを読み込む
   */
  async get() {
    //ボタン無効＋ローダー表示
    //-----------------
    this.btnDisable = true;
    const panel = document.getElementsByClassName("panel-container");
    Array.from(panel).map((element: Element) => {
      element.classList.add("enable-loader");
    });

    try {
      //処理
      //-----------------
      Cl_common.logger("処理実行");

      //パラメータにIDが指定されていなければ、新規追加モードでデータを読み込まない
      //-------
      let id = Cl_common.getParam("id");
      if (id == "") {
        //新規追加
        this.isEditMode = false;
        //初期値設定
        //this.delegate.c_client_company_type = 1;
        //this.delegate.c_client_flag_company_signage_posi = 1;

        this.domGoalEarnings = "0";
        this.domGoalGross = "0";

        return;
      } else {
        //編集
        this.isEditMode = true;
      }

      //準備
      //-------
      let dto = new DtoGoalsGetReqImple();

      dto.c_goal_id = Number(id);

      //API実行
      //-------
      this.delegate = await Cl_goal.get(dto);

      Cl_common.logger("delegate");
      Cl_common.logger(this.delegate);

      //レスポンス処理
      //-------
      //IDがnullなら一覧へ遷移
      if (this.delegate.c_goal_id == null) {
        this.$router.push("/personalGoalList");
      }

      this.domGoalEarnings =
        this.delegate.c_goal_earnings!.toLocaleString("ja-JP");
      this.domGoalGross = this.delegate.c_goal_gross!.toLocaleString("ja-JP");
    } catch (error) {
      //モーダルのメッセージを設定
      this.message4ModalErrorConf = "エラーが発生しました";
      //モーダル表示
      const modal: any = this.$refs.Mo_modal_errorConf;
      modal.showModal();

      Cl_common.logger(error);
    } finally {
      //ボタン無効解除＋ローダー非表示
      //-----------------
      this.btnDisable = false;
      Array.from(panel).map((element: Element) => {
        element.classList.remove("enable-loader");
      });
    }
  }

  /**
   */
  async upd(isDel: boolean) {
    //ボタン無効＋ローダー表示
    //-----------------
    this.btnDisable = true;
    const panel = document.getElementsByClassName("panel-container");
    Array.from(panel).map((element: Element) => {
      element.classList.add("enable-loader");
    });

    try {
      //処理
      //-----------------
      Cl_common.logger("処理実行");

      //準備
      //-------
      let dto = new DtoGoalsPutReq();
      if (isDel) {
        //削除処理：削除フラグを立てる。
        dto.c_goal_id = this.delegate.c_goal_id;
        dto.c_goal_flag_del = 1;
      } else {
        //更新処理：delegateからdtoにデータ投入。
        const parsedEarn = parseInt(this.domGoalEarnings.replace(/,/g, ""), 10);
        const parsedGross = parseInt(this.domGoalGross.replace(/,/g, ""), 10);

        //-------
        if (
          this.domGoalEarnings == "0" ||
          this.domGoalEarnings == "" ||
          !(
            !isNaN(parsedEarn) &&
            String(parsedEarn) === this.domGoalEarnings.replace(/,/g, "")
          )
        ) {
          this.delegate.c_goal_earnings = 0;
        } else {
          this.delegate.c_goal_earnings = Number(
            this.domGoalEarnings.replace(/,/g, "")
          );
        }
        //-------
        if (
          this.domGoalGross == "0" ||
          this.domGoalGross == "" ||
          !(
            !isNaN(parsedGross) &&
            String(parsedGross) === this.domGoalGross.replace(/,/g, "")
          )
        ) {
          this.delegate.c_goal_gross = 0;
        } else {
          this.delegate.c_goal_gross = Number(
            this.domGoalGross.replace(/,/g, "")
          );
        }
        //-------

        dto = Object.assign(new DtoGoalsPutReq(), this.delegate);
      }

      //API実行
      //-------
      await Cl_goal.put(dto);
      //レスポンスの処理
      //-------

      //更新処理：
      //モーダルのメッセージを設定
      if (isDel) {
        //削除処理：
        this.message4ModalSuccess = "データを削除しました。";
      } else {
        //更新処理：
        this.message4ModalSuccess = "データを更新しました。";
      }

      //モーダルを表示
      const modal: any = this.$refs.Mo_modal_success;
      modal.showModal();
    } catch (error) {
      //モーダルのメッセージを設定
      this.message4ModalErrorConf = "エラーが発生しました";
      //モーダル表示
      const modal: any = this.$refs.Mo_modal_errorConf;
      modal.showModal();

      Cl_common.logger(error);
    } finally {
      //ボタン無効解除＋ローダー非表示
      //-----------------
      this.btnDisable = false;
      Array.from(panel).map((element: Element) => {
        element.classList.remove("enable-loader");
      });
    }
  }

  /**
   * データを新たに登録する
   */
  async add() {
    //ボタン無効＋ローダー表示
    //-----------------
    this.btnDisable = true;
    const panel = document.getElementsByClassName("panel-container");
    Array.from(panel).map((element: Element) => {
      element.classList.add("enable-loader");
    });

    try {
      //処理
      //-----------------
      Cl_common.logger("処理実行");

      //準備
      //-------
      const parsedEarn = parseInt(this.domGoalEarnings.replace(/,/g, ""), 10);
      const parsedGross = parseInt(this.domGoalGross.replace(/,/g, ""), 10);

      //-------
      if (
        this.domGoalEarnings == "0" ||
        this.domGoalEarnings == "" ||
        !(
          !isNaN(parsedEarn) &&
          String(parsedEarn) === this.domGoalEarnings.replace(/,/g, "")
        )
      ) {
        this.delegate.c_goal_earnings = 0;
      } else {
        this.delegate.c_goal_earnings = Number(
          this.domGoalEarnings.replace(/,/g, "")
        );
      }
      //-------
      if (
        this.domGoalGross == "0" ||
        this.domGoalGross == "" ||
        !(
          !isNaN(parsedGross) &&
          String(parsedGross) === this.domGoalGross.replace(/,/g, "")
        )
      ) {
        this.delegate.c_goal_gross = 0;
      } else {
        this.delegate.c_goal_gross = Number(
          this.domGoalGross.replace(/,/g, "")
        );
      }
      //-------
      let dto = Object.assign(new DtoGoalsPostReq(), this.delegate);
      dto.c_goal_flag_del = 0;

      // if (
      //   this.domYear != null &&
      //   this.domYear.label != null &&
      //   this.domYear.label != ""
      // ) {
      //   dto.c_goal_year = Number(this.domYear.label);
      //   Cl_common.logger("dto.c_goal_year");
      //   Cl_common.logger(dto.c_goal_year);
      // }

      //API実行
      //-------
      const res = await Cl_goal.post(dto);

      //レスポンスの処理
      //-------
      //編集画面のURL作成
      this.$router.push({
        path: "/personalGoalEdit",
        query: { id: res.c_goal_id },
      });

      //モーダルのメッセージを設定
      this.message4ModalSuccess = "正常に追加されました";

      //モーダルを表示
      const modal: any = this.$refs.Mo_modal_success;
      modal.showModal();
    } catch (error) {
      //モーダルのメッセージを設定
      this.message4ModalErrorConf = "エラーが発生しました";
      //モーダル表示
      const modal: any = this.$refs.Mo_modal_errorConf;
      modal.showModal();

      Cl_common.logger(error);
    } finally {
      //ボタン無効解除＋ローダー非表示
      //-----------------
      this.btnDisable = false;
      Array.from(panel).map((element: Element) => {
        element.classList.remove("enable-loader");
      });
    }
  }

  /**
   * データ削除用のモーダルを表示
   */
  async delConf() {
    //モーダルのメッセージを設定
    this.message4ModalDelConf =
      "【" +
      this.delegate.c_goal_id +
      "】" +
      this.delegate.c_goal_year +
      "を削除します。よろしいですか？";
    //モーダル表示
    const modal: any = this.$refs.Mo_modal_deleteConf;
    modal.showModal();
  }
  /**
   * データを削除する
   */
  async del() {
    //削除フラグのあるテーブルなので更新処理。
    this.closeModal4deleteConf();
    this.upd(true);
  }

  /**
   * 金額セル入力時の処理
   * カンマを消す
   * @param obj
   */
  kanmaDelEarn() {
    // //カンマを消す
    this.domGoalEarnings = this.domGoalEarnings.replace(/,/g, "");
    if (this.domGoalEarnings == "0") this.domGoalEarnings = "";
  }
  /**
   * 金額セル入力時の処理
   * カンマを付ける
   * @param obj
   */
  kanmaInsEarn() {
    let val: string = this.domGoalEarnings;

    //うっかり入力しているかもしれないカンマを消す
    val = val.replace(/,/g, "");
    //整数に変換したのち文字列に戻す
    //この時点で数字とマイナス記号だけが残る
    let num = "" + parseInt(val);
    //正規表現で桁区切りするための良く見かける関数的な何か
    //変数 num の中身が、桁区切りされる
    while (num != (num = num.replace(/^(-?\d+)(\d{3})/, "$1,$2")));
    //numに入っている値が数値じゃないときは空白とする
    if (isNaN(parseInt(num))) num = "";
    //桁区切りした結果（変数 num）でテキストボックスの中身を書き換える
    this.domGoalEarnings = num;
  }
  /**
   * 金額セル入力時の処理
   * カンマを消す
   * @param obj
   */
  kanmaDelGross() {
    // //カンマを消す
    this.domGoalGross = this.domGoalGross.replace(/,/g, "");
    if (this.domGoalGross == "0") this.domGoalGross = "";
  }
  /**
   * 金額セル入力時の処理
   * カンマを付ける
   * @param obj
   */
  kanmaInsGross() {
    let val: string = this.domGoalGross;

    //うっかり入力しているかもしれないカンマを消す
    val = val.replace(/,/g, "");
    //整数に変換したのち文字列に戻す
    //この時点で数字とマイナス記号だけが残る
    let num = "" + parseInt(val);
    //正規表現で桁区切りするための良く見かける関数的な何か
    //変数 num の中身が、桁区切りされる
    while (num != (num = num.replace(/^(-?\d+)(\d{3})/, "$1,$2")));
    //numに入っている値が数値じゃないときは空白とする
    if (isNaN(parseInt(num))) num = "";
    //桁区切りした結果（変数 num）でテキストボックスの中身を書き換える
    this.domGoalGross = num;
  }

  //----------------------
  //モーダル用メソッド
  //----------------------
  async closeModal4deleteConf(): Promise<void> {
    const modal: any = this.$refs.Mo_modal_deleteConf;
    modal.closeModal();
  }
  async closeModal4ErrorConf(): Promise<void> {
    const modal: any = this.$refs.Mo_modal_errorConf;
    modal.closeModal();
  }
}
</script>
